module.exports = __webpack_public_path__ + "img/whereby.96e7c2d.gif";